import * as React from "react"
import Api, {APIs} from "../../../Api";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import Table from "@mui/material/Table";
import { StyledTableCell } from "./sro/SROInfo";
import {StyledTableRow} from "../../digitalarz/data-grid/TypeDeclaration";
import {makeHeading} from "../../digitalarz/data-grid/components/utils";


interface IPledgeInfo{
    id: number
    entity: string
    amount: number
    loan: number
    grant: number
    entity_type: string
}



const MultiLiteralPledgeInfo = () => {
    const [pledgeInfo, setPledgeInfo] = React.useState<IPledgeInfo[]>([])
    React.useEffect(() => {
        Api.get(APIs.MoPD_PLEDGE_INFO).then((payload) => {
            if (payload) {
                const ml = payload.filter((item: IPledgeInfo)=> item.entity_type==="Multilateral")
                setPledgeInfo(ml)
            }
        });
    }, [])
    return(
        <React.Fragment>
            <Table sx={{minWidth: 700}} aria-label="pledge-info table">
                <TableHead>
                    <TableRow>
                        {pledgeInfo.length > 0 && Object.keys(pledgeInfo[0]).map((key) => <StyledTableCell
                            key={"head-" + key}>{makeHeading(key)}</StyledTableCell>)}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {pledgeInfo.map((row:any, index:number) => (
                        <StyledTableRow key={"row-" + index}>
                            {pledgeInfo.length > 0 && Object.keys(pledgeInfo[0]).map((key) => <StyledTableCell
                                key={`row-${index}-${key}`}>{row[key]}</StyledTableCell>)}

                        </StyledTableRow>
                    ))}
                </TableBody>
            </Table>
        </React.Fragment>
    );
}

export default MultiLiteralPledgeInfo
